import { render, staticRenderFns } from "./CompWeekList.vue?vue&type=template&id=88284e4e&scoped=true"
import script from "./CompWeekList.vue?vue&type=script&lang=js"
export * from "./CompWeekList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88284e4e",
  null
  
)

export default component.exports